import { createStructuredSelector } from 'reselect';
import omit from 'lodash/omit';
import { querySelectors } from 'store/router/routerSelectors';
import { getSearchType } from './searchSelectors';

export const getPropertyLinkQuery = createStructuredSelector({
  ...omit(querySelectors, ['utm_campaign', 'utm_source', 'featuredPropertyId', 'featuredOfferId']),
  searchType: getSearchType,
});
